import { useEffect, useState } from "react";
import { Gift, Loader2, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { api, errMsg, fmtDate } from "@/lib/api";
import { toast } from "sonner";

export const DURATIONS = [["1", "1 mese"], ["3", "3 mesi"], ["6", "6 mesi"], ["12", "12 mesi"], ["0", "Per sempre"]];
export const durLabel = (m) => DURATIONS.find(([v]) => v === String(m))?.[1];

export const GiftPanel = ({ email, setEmail, onDone }) => {
  const [months, setMonths] = useState("1");
  const [busy, setBusy] = useState(false);
  const [pending, setPending] = useState([]);
  const loadPending = () => api.get("/admin/pending-gifts").then(({ data }) => setPending(data));
  useEffect(() => {
    loadPending();
  }, []);

  const give = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/admin/gift", { email, months: Number(months) });
      toast.success(data.message);
      setEmail("");
      onDone();
      loadPending();
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };
  const removePending = async (e) => {
    await api.delete(`/admin/pending-gifts/${encodeURIComponent(e)}`);
    loadPending();
  };

  return (
    <div className="rounded-3xl border bg-white p-6" data-testid="gift-panel">
      <h3 className="font-medium flex items-center gap-2"><Gift className="h-4 w-4 text-[#E07A5F]" /> Regala il piano Pro</h3>
      <p className="mt-1 text-sm text-slate-500">Funziona anche con chi non è ancora iscritto: riceverà il Pro appena si registra con quella email.</p>
      <div className="mt-4 flex flex-col md:flex-row gap-2">
        <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="email@esempio.it" className="h-11" data-testid="gift-email-input" />
        <Select value={months} onValueChange={setMonths}>
          <SelectTrigger className="md:w-44 h-11" data-testid="gift-duration-select"><SelectValue /></SelectTrigger>
          <SelectContent>{DURATIONS.map(([v, l]) => <SelectItem key={v} value={v}>{l}</SelectItem>)}</SelectContent>
        </Select>
        <Button onClick={give} disabled={busy || !email.includes("@")} className="h-11 rounded-full px-6" data-testid="gift-submit-btn">
          {busy && <Loader2 className="h-4 w-4 mr-2 animate-spin" />} Regala
        </Button>
      </div>
      {pending.length > 0 && (
        <div className="mt-4">
          <p className="text-xs uppercase tracking-[0.15em] text-slate-500">In attesa di iscrizione</p>
          {pending.map((p) => (
            <div key={p.email + p.created_at} className="mt-2 flex items-center justify-between rounded-xl bg-slate-50 px-3 py-2 text-sm" data-testid={`pending-gift-${p.email}`}>
              <span>{p.email} · {durLabel(p.months)} · {fmtDate(p.created_at)}</span>
              <button onClick={() => removePending(p.email)} className="p-1 text-slate-500 hover:text-red-600" data-testid={`pending-gift-remove-${p.email}`}><X className="h-4 w-4" /></button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
